module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/users.svg?95fce71e49feb950e6972338b520ae88";